import { render } from "./Content.vue?vue&type=template&id=39cb6146&scoped=true"
const script = {}

import "./Content.vue?vue&type=style&index=0&id=39cb6146&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cb6146"]])

export default __exports__